module.exports = __webpack_public_path__ + "img/firma_template4.dd73d12.svg";